import React from 'react';
import './FmVerdictChipSlot.css';

export interface FmVerdictChipSlotProps {
  /** Content injected by consuming pages (planner). Empty by default. */
  children?: React.ReactNode;
}

/**
 * FmVerdictChipSlot — floating shell slot for the value/yield verdict chip.
 *
 * Glass pill anchored above the scrubber; the planner epic populates it with
 * a FmChip summarising the plan verdict (e.g. "Sell now · +12%").
 * Accepts `children` so consuming pages can inject content without DOM hacks.
 * `aria-hidden` applied only when slot is empty.
 *
 * data-testid="fm-verdict-chip-slot" — always attached to the DOM.
 */
export const FmVerdictChipSlot: React.FC<FmVerdictChipSlotProps> = ({ children }) => (
  <div
    className="fm-verdict-chip-slot"
    data-testid="fm-verdict-chip-slot"
    aria-hidden={!children ? true : undefined}
  >
    {children}
  </div>
);

export default FmVerdictChipSlot;
